import React, { useEffect, useState } from "react";
import { api } from "../../lib/auth";

export default function Volunteer() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/portal/volunteer-opportunities").then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-extrabold tracking-tight text-[#0B132B]">Volunteer Hub</h1>
        <p className="text-[#4B5563] mt-2">Get matched to opportunities that fit your skills, schedule, and heart.</p>
      </div>
      <div className="grid gap-4">
        {items.map((v) => (
          <div key={v.id} className="bg-white rounded-2xl border border-gray-100 p-6 flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div>
              <h3 className="font-bold text-[#0B132B] text-lg">{v.title}</h3>
              <div className="text-xs text-[#1A5FAB] font-semibold mt-1">{v.commitment} • {v.location}</div>
              <p className="text-sm text-[#4B5563] mt-2">{v.description}</p>
            </div>
            <button className="btc-btn-primary text-sm">Apply</button>
          </div>
        ))}
      </div>
    </div>
  );
}
